"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
var _menuStoreTemplateManage = _interopRequireDefault(require("./menuStoreTemplateManage.vue"));
var _detail = _interopRequireDefault(require("./detail.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '门店菜单',
  components: {
    menuStoreTemplateManage: _menuStoreTemplateManage.default,
    detail: _detail.default
  },
  data: function data() {
    return {
      activeTab: 'manage',
      panes: [{
        label: '店铺模板',
        name: 'manage'
      }]
    };
  },
  methods: {
    handleTabRemove: function handleTabRemove(name) {
      if (name === 'manage') return;
      var idx = this.panes.findIndex(function (p) {
        return p.name === name;
      });
      if (idx !== -1) {
        this.panes.splice(idx, 1);
        // 若关闭的是当前活动 Tab，自动切回管理 Tab
        if (this.activeTab === name) {
          this.activeTab = 'manage';
        }
      }
    },
    handleEditTemplate: function handleEditTemplate(templateId) {
      var name = "detail-".concat(templateId);
      var exists = this.panes.find(function (p) {
        return p.name === name;
      });
      if (!exists) {
        // 先占位，再异步获取名称
        this.panes.push({
          label: '模板详情',
          name: name,
          templateId: templateId
        });
      }
      this.activeTab = name;
    }
  }
};